module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_21-c997041f2fc11a48769f18c7a72365a1.jpg";